import {
  doc,
  setDoc,
  serverTimestamp,
  getDoc,
  getDocs,
  collection,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';
import { getAuth } from 'firebase/auth';

const saveThreadToFirestore = async (userUid, threadData) => {

  console.log('🧠 Saving thread — UID:', userUid);
  console.log('📝 Thread Data:', threadData);

  if (!userUid || !threadData || !threadData.id) {
    console.error('❌ Missing authenticated user UID or threadData.id in saveThreadToFirestore');
    return;
  }

  const { id, data = {}, pinned, ...rest } = threadData;
  const docRef = doc(db, 'users', userUid, 'threads', id);
  const existingDoc = await getDoc(docRef);

  let position;
  let currentPinned = typeof pinned === 'boolean' ? pinned : undefined;

  if (existingDoc.exists()) {
    const existingData = existingDoc.data();
    position = existingData?.position ?? 0;
    if (currentPinned === undefined) currentPinned = existingData?.pinned;
  } else {
    const threadsRef = collection(db, 'users', userUid, 'threads');
    const snapshot = await getDocs(threadsRef);
    position = snapshot.docs.length;
  }

  const getThreadType = (data, metadata = {}, fallback = 'industry') => {
    if (data?.industry) return 'industry';
    if (data?.campaign) return 'prospecting';
    if (data?.prepData) return 'prep';
    if (data?.prepResultFull) return 'prep'; // ✅ New detection logic for Prep threads
    if (data?.postCallData) return 'postcall';
    if (data?.postCallResultFull) return 'postcall'; // ✅ NEW: supports current Post-Call format
    if (data?.chat) return 'home';
    return fallback;
  };

  const smartType = getThreadType(data, rest.metadata, rest.type || 'industry');

  const payload = {
    id,
    name: rest.name || 'Unnamed Thread',
    type: smartType,
    folders: [],
    data: Object.keys(data).length > 0 ? data : { placeholder: true },
    metadata: rest.metadata || {},
    updatedAt: serverTimestamp(),
    position,
  };

  if (!existingDoc.exists()) {
    payload.createdAt = serverTimestamp();
  }

  if (currentPinned !== undefined) {
    payload.pinned = currentPinned;
  }

  if (!existingDoc.exists() && rest.name) {
    payload.name = rest.name;
  }

  console.log('📤 Saving to path:', docRef.path);
  console.log('📦 Final payload:', payload);

  try {
    if (!existingDoc.exists()) {
      await setDoc(docRef, payload); // No merge — full set on first write
    } else {
      await setDoc(docRef, payload, { merge: true }); // Merge on updates
    }
    console.log('✅ Thread saved successfully:', id);
  } catch (error) {
    console.error('❌ Failed to save thread:', error);
  }
};

export default saveThreadToFirestore;

